import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import Paper from '../Paper';
import PaperTitle from '../PaperTitle';
import Grid from '@material-ui/core/Grid';
import {useOktaAuth} from '@okta/okta-react';
import Button from 'components/CTA/SGButton';
import {useDispatch, useSelector} from 'react-redux';
import {unsetUserInfo} from 'redux/actions';
import SGBody from 'components/Typography/SGBody';

const StyledPaper = styled(Paper)`
  code {
    width: 100%;
    word-wrap: break-word;
    display: inline-block;
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
`;

const StyledCopyBlock = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  align-items: center;
`;

const StyledCopyMessage = styled(SGBody)`
  color: ${props => props.theme.subtleText};
`;

const StyledCodeBlock = styled.code`
  display: block;
  background-color: ${props => props.theme.navBg};
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.tableRow};
  user-select: all;
  color: ${props => props.theme.grey};
`;

const StyledButton = styled(Button)``;

function OktaKey() {
  const dispatch = useDispatch();
  const {authState, oktaAuth} = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [oktaKey, setOktaKey] = useState('');
  const [copyMessage, setCopyMessage] = useState(null);

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else if (authState.isAuthenticated) {
      const accessToken = oktaAuth.getAccessToken();
      setOktaKey(accessToken);
      oktaAuth.getUser().then(info => {
        setUserInfo(info);
      });
    }
  }, [authState, oktaAuth]); // Update if authState changes

  const onClickCopy = () => {
    navigator.clipboard
      .writeText(oktaKey)
      .then(() => {
        console.log('Okta key copied to clipboard');
        setCopyMessage('Okta key copied to clipboard');
      })
      .catch(err => {
        console.error('Failed to copy Okta key: ', err);
        setCopyMessage('Failed to copy Okta key');
      });
  };

  useEffect(() => {
    if (copyMessage) {
      const timer = setTimeout(() => {
        setCopyMessage(null);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [copyMessage]);

  return (
    <StyledPaper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PaperTitle>User Info</PaperTitle>
        </Grid>
        <Grid item xs={12}>
          <code>{userInfo ? userInfo.name : ''}</code>
          <code>{userInfo ? userInfo.email : ''}</code>
          <code>{userInfo ? userInfo.locale : ''}</code>
          <code>{userInfo ? userInfo.zoneinfo : ''}</code>
        </Grid>

        <Grid item xs={12}>
          <PaperTitle>Access Key</PaperTitle>
        </Grid>
        <Grid item xs={12}>
          <StyledCopyBlock>
            <StyledButton variant="outlined" onClick={onClickCopy}>
              Copy Okta Key
            </StyledButton>
            {copyMessage && <StyledCopyMessage>{copyMessage}</StyledCopyMessage>}
          </StyledCopyBlock>
          <StyledCodeBlock>{oktaKey}</StyledCodeBlock>
        </Grid>

        <Grid item xs={12}>
          <Button
            onClick={() => {
              dispatch(unsetUserInfo());
              return oktaAuth.signOut();
            }}
          >
            Sign Out of Okta
          </Button>
        </Grid>
      </Grid>
    </StyledPaper>
  );
}

export default OktaKey;
